import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'

import config from '../../config.js'

import {setMetatags} from '../../modules/metatag_functions.js'
import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
// import refresh_icon from './28406.svg';


class Blogs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {page:0};

    setMetatags("Blogs", null, null, null, props.pathname);
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
    } else {
      this.props.fetchDataIfReady(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs", undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs?t="+nextProps.session_token, undefined, {"PM-List-Page":this.state.page});
    } else {
      this.props.fetchDataIfUndefined(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs", undefined, {"PM-List-Page":this.state.page});
    }
  }

  render() {
    let cards = null, end_of_list_text = "", page_cards = this.props.apiData["blogs_overview"], pager = null;

    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        let cd = new Date(item.created_at);
        let cd_txt = cd.getDate()+" "+cd.toLocaleString('default', { month: 'long' })+" "+cd.getFullYear();
        let cd_time = <time datetime={cd.getFullYear()+"-"+(cd.getMonth()+1)+"-"+cd.getDate()}>{cd_txt}</time>;
        let item_link = "/blog/"+item.title.replace(/ /g, "-").replace("#-", "").replace(/#/g, "").replace(/,/g, "")+"-"+item.ref_id;

        return <div key={"1k"+i} className="col-1"><div className="card thumbnail-card">
          <div className="image-container"><Link to={item_link} onClick={() => document.getElementById("main").scrollIntoView(true)}><img src={"https://images.dieet.club/"+item.img_fn} alt={"Dieet.Club | "+item.title} /></Link></div>
          <h1><Link to={item_link} onClick={() => document.getElementById("main").scrollIntoView(true)}>{item.title}</Link></h1>
          {item.is_article === 1 && <h2><span className="contact-label" style={{background:"transparent", color:"#000", border:"2px solid #000", borderRadius:"0"}}>Dieet.Club Artikel</span></h2>}
          <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>{cd_time}</small>
        </div></div>;
      });

      let pager_prev = null, pager_next = null, first_page = null, current_page = null;
      if(page_cards.page && page_cards.pagesize) {
        if(page_cards.page > 0) {
          pager_prev = <div style={{display:"inline", cursor:"pointer"}} onClick={() => this.handlePager(parseInt(page_cards.page, 10)-1)}>vorige</div>;
        } else {
          pager_prev = <div style={{opacity:".3", display:"inline", cursor:"pointer"}}>vorige</div>;
        }
        if(!page_cards.limitReached) {
          pager_next = <div style={{display:"inline", cursor:"pointer"}} onClick={() => this.handlePager(parseInt(page_cards.page, 10)+1)}>volgende</div>;
        } else {
          pager_next = <div style={{opacity:".3", display:"inline", cursor:"pointer"}}>volgende</div>;
        }
        if(page_cards.page > 0) {
          first_page = <div style={{display:"inline", cursor:"pointer"}} onClick={() => this.handlePager(0)}>1</div>;
          current_page = <div style={{display:"inline"}}> .. <u>{parseInt(page_cards.page, 10)+1}</u> | </div>;
        }
      }
      pager = <div style={{textAlign:"center", userSelect:"none"}}>{pager_prev} | {first_page}{current_page}{pager_next}</div>;
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        // end_of_list_text = "Einde van resultaten.";
      } else {
        end_of_list_text = "Geen blogs.";
      }
    }

    return (
      <div className="container content header-offset">
        {/*<div className="card-layout">
          <div className="card-layout-div50"><strong>Blogs</strong></div>
          <div className="card-layout-div50 refresher"><img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        </div>*/}
        {page_cards !== undefined && page_cards.data[0] !== undefined && cards}
        {page_cards !== undefined && pager}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  // refresh() { // mss een automatische check na x aantal uren? die dus bijv het laatste ID vergelijkt met het laatste ID van deze user
  //   this.props.clearStateBlock("blog_list");
  // }

  handlePager(page) {
    this.setState({page});
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs?t="+this.props.session_token, undefined, {"PM-List-Page":page}, true);
    } else {
      this.props.fetchDataIfReady(config.api_token, "blogs_overview", "GET", config.api_url+"/blogs", undefined, {"PM-List-Page":page}, true);
    }
    document.getElementById("main").scrollIntoView(true);
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Blogs)



// WEBPACK FOOTER //
// ./src/containers/StartPages/Blogs.js